import React from 'react';
import Styles from './styles.js';

export default function PeaceOfMind({ imgSrc, title, para, order1, order2, order3, order4 }) {
  return (
    <>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-x-12 ">
        <div className={`md:order-${order3} order-${order1}`}>
          <img className="w-full h-fit-content" src={imgSrc} alt="" />
        </div>
        <div className={`md:order-${order4} order-${order2} flex flex-col justify-center items-center md:pt-0 pt-6`}>
          <h4 className="POF-sub-title lg:text-2xl text-xl lg:mb-6 mb-4 text-center">{title}</h4>
          <p className="POF-sub-para lg:text-lg text-base text-center">{para}</p>
        </div>
      </div>

      <Styles />
    </>
  );
}
